import { Button } from "@mui/material";
import React from "react";

function AddNoteButtonMobile(props) {
  return (
    <Button
      style={{
        width: "auto",
        height: "30px",
        marginRight: "40px",
        marginLeft: "40px",
        fontSize: "10px",
      }}
      variant="contained"
      onClick={props.handleOpen}
    >
      {props.title}
    </Button>
  );
}

export default AddNoteButtonMobile;
